module.exports = __webpack_public_path__ + "static/api-launch-min-dfcfdaafbd6783ae1f277e5e9c73e9fe.jpg";